import React from "react";
import styled from "styled-components";
import { ProductConsumer } from "../../context";
import CartItem from "./CartItem";
import DeliveryPrice from "./DeliveryPrice";
import TotalPrice from "./TotalPrice";
import MomsPrice from "./MomsPrice";
import DinordreSendt from "./DinordreSendt";

export default function OrderInfo(product) {
  return (
    <ProductConsumer>
      {(value) => {
        const {
          errors,
          deliveryOption,
          cart,
          telefon,
          navn,
          message,
          adress,
          postnr,
          email,
          errorDelivery,
          handleChange,
          handleContactForm,
        } = value;
        let addres = " ";
        if (deliveryOption === "Udbringning") {
          addres = (
            <div className="row">
              <div className="col-md-6">
                <div className="md-form mb-0">
                  <input
                    type="text"
                    id="adress"
                    name="adress"
                    className="form-control"
                    onChange={handleChange}
                    value={adress}
                  />
                  <label htmlFor="subject" className="">
                    Adress <p>{errors.adress}</p>
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="md-form mb-0">
                  <input
                    type="text"
                    id="postnr"
                    name="postnr"
                    className="form-control"
                    onChange={handleChange}
                    value={postnr}
                  />
                  <label htmlFor="subject" className="">
                    Postnr<p>{errors.postnr}</p>
                  </label>
                </div>
              </div>
            </div>
          );
        } else {
        }

        return (
          <OrderInfoWrapper className="container">
            <h2 className="h1-responsive font-weight-bold text-center my-4">
              Næsten færdig! Udfyld dine oplysninger{" "}
            </h2>

            <section>
              <div className="row">
                <div className="col-md-6 mb-md-0 mb-5">
                  <form id="contact-form">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            required
                            type="text"
                            id="name"
                            name="navn"
                            className="form-control"
                            onChange={handleChange}
                            value={navn}
                          />
                          <label htmlFor="navn" className="">
                            Navn & Efternavn <p>{errors.navn}</p>
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            required
                            type="text"
                            id="email"
                            name="email"
                            className="form-control"
                            onChange={handleChange}
                            value={email}
                          />
                          <label htmlFor="email" className="">
                            Email <p>{errors.email}</p>
                          </label>
                        </div>
                      </div>
                    </div>
                    {addres}
                    <div className="row">
                      <div className="col-md-6">
                        <div className="md-form mb-0">
                          <input
                            required
                            type="text"
                            id="telefon"
                            name="telefon"
                            className="form-control"
                            onChange={handleChange}
                            value={telefon}
                          />
                          <label htmlFor="telefon" className="">
                            Telefon <p>{errors.telefon}</p>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="md-form">
                          <textarea
                            type="text"
                            id="message"
                            name="message"
                            rows="2"
                            className="form-control md-textarea"
                            onChange={handleChange}
                            value={message}
                          ></textarea>
                          <label htmlFor="message">Kommentar</label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <CheckboxWrapper>
                          <input
                            type="checkbox"
                            id="termsAccepted"
                            name="termsAccepted"
                            required
                            onChange={handleChange}
                          />
                          <label htmlFor="termsAccepted">
                            Jeg accepterer{" "}
                            <a
                              href="/handelsbetingelser"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              handelsbetingelserne
                            </a>{" "}
                            og samtykker til behandling af mine
                            personoplysninger (GDPR)
                          </label>
                        </CheckboxWrapper>
                        <p>{errors.termsAccepted}</p>
                      </div>
                    </div>

                    <div className="text-center text-md-left">
                      <button
                        className="btn btn-primary"
                        onClick={handleContactForm}
                      >
                        Send
                      </button>
                    </div>
                    <div className="status">
                      <p className="danger">{errorDelivery}</p>
                    </div>
                  </form>
                  <DinordreSendt />
                </div>

                <div className="col-md-6 text-center">
                  {cart.map((item) => (
                    <CartItem
                      key={JSON.stringify(item)}
                      cartItem={item}
                    ></CartItem>
                  ))}
                  {/* <DeliveryPrice></DeliveryPrice> */}
                  <TotalPrice></TotalPrice>
                  <MomsPrice></MomsPrice>
                </div>
              </div>
            </section>
          </OrderInfoWrapper>
        );
      }}
    </ProductConsumer>
  );
}

const OrderInfoWrapper = styled.div`
  p {
    color: red;
    font-size: 0.7rem;
  }
`;
const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
`;
